export default __webpack_public_path__ + "static/media/img (3).3d7514b6.jpg";